import { get } from "../methods";
function getDashboardEvent(payload, headers = {}) {
  return get({
    url: `dashboard/events/${payload.companyId.toLowerCase()}/${payload.activityId}`,
    headers
  });
}
export {
  getDashboardEvent as default
};
